import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useCallback } from "react";
import { elementAction, feedbackAction } from "../../../store";
import Uwp from "../../../utils/uwp";

// --- 邏輯鉤子 (Hook) ---
// 職責：處理業務邏輯、副作用和狀態管理
export const useSubmitDialogLogic = (props) => {
  const { id, t } = props;
  const dispatch = useDispatch();
  const dialogRef = useRef(null);

  const {
    submitStatus,
    totalProgress,
    theme,
    isShowSubmitDialog,
    uploadStatus,
    enableRemoteCode,
    reportCode,
  } = useSelector((state) => ({
    submitStatus: state.feedback.submitStatus,
    totalProgress: state.feedback.totalProgress,
    theme: state.element.theme,
    isShowSubmitDialog: state.element.isShowSubmitDialog,
    uploadStatus: state.uwp.uploadStatus,
    enableRemoteCode: state.uwp.enableRemoteCode,
    reportCode: state.element.reportCode,
  }));

  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog) {
      isShowSubmitDialog ? dialog.showModal() : dialog.close();
    }
  }, [isShowSubmitDialog]);

  useEffect(() => {
    const dialogElement = document.getElementById(id);
    const overlayElement = document.getElementById(`${id}-overlay`);

    const preventDefault = (event) => {
      event.preventDefault();
      document.getElementById("submit")?.focus();
    };
    const preventTouchMove = (e) => e.preventDefault();

    dialogElement?.addEventListener("cancel", preventDefault);
    overlayElement?.addEventListener("touchmove", preventTouchMove, { passive: false });

    return () => {
      dialogElement?.removeEventListener("cancel", preventDefault);
      overlayElement?.removeEventListener("touchmove", preventTouchMove);
    };
  }, [id]);

  useEffect(() => {
    if (totalProgress === 100) {
      dispatch(feedbackAction.setAttachmentFileUploadDone());
    }
  }, [totalProgress, dispatch]);

  const confirm = useCallback(async () => {
    await Uwp.clearWebContent();
    if (enableRemoteCode && reportCode !== "") {
      dispatch(elementAction.setReportCodeMode(1));
      dispatch(elementAction.triggerReportCodeDialog(true));
      dispatch(elementAction.triggerSubmitDialog(false));
      return;
    }
    Uwp.redirectToSettingsPage();
    window.location.href = "/ac-feedback-hub";
  }, [dispatch, enableRemoteCode, reportCode]);

  const handleSubmit = useCallback(async () => {
    switch (submitStatus) {
      case 0:
        if (Uwp.getBridge()) await Uwp.cancelUploadLogFile();
        dispatch(feedbackAction.submitInit());
        break;
      case 1:
        if (Uwp.getBridge()) await Uwp.resetUploadLogFileStatus();
        await confirm();
        break;
      case 2:
      case 3:
        if (Uwp.getBridge()) await Uwp.resetUploadLogFileStatus();
        dispatch(feedbackAction.submitInit());
        break;
      case 4:
        await Uwp.redirectToMSSTore("");
        window.location.href = "/ac-feedback-hub/like-confirm";
        break;
      default:
        break;
    }
    dispatch(feedbackAction.setLogUploadProgress(0));
    dispatch(elementAction.triggerDialog({ id, isOpen: false }));
  }, [submitStatus, confirm, dispatch, id]);

  return {
    dialogRef,
    theme,
    submitStatus,
    totalProgress,
    uploadStatus,
    handleSubmit,
    t,
  };
};
